var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUniversity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9933"
    },
    points: "0,227.63 82.424,206.732 61.526,478.24 0,478.24 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D5681E"
    },
    points: "143.948,206.732 123.05,478.24 61.526,478.24 61.526,227.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D5681E"
    },
    points: "512,227.63 429.576,206.732 450.474,478.24 512,478.24  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9933"
    },
    points: "368.052,206.732 388.95,478.24 450.474,478.24 450.474,227.63 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#663300"
    },
    points: "271.673,141.395 271.673,71.629 256,90.562 235.102,227.63 512,227.63 512,141.395 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#983300"
    },
    points: "240.327,109.497 240.327,141.395 0,141.395 0,227.63 256,227.63 256,90.562 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF0F4D"
    },
    points: "240.327,109.497 342.804,71.629 271.673,61.18 240.327,71.629 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4F67"
    },
    points: "240.327,71.629 342.804,71.629 240.327,33.76 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D5681E"
    },
    points: "388.95,227.63 256,141.395 235.102,322.081 256,478.24 388.95,478.24 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9933"
    },
    points: "123.05,227.63 123.05,478.24 256,478.24 256,141.395 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.852,
    y: 337.032,
    style: {
      fill: "#FDE09C"
    },
    width: 31.347,
    height: 31.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.852,
    y: 283.679,
    style: {
      fill: "#FDE09C"
    },
    width: 31.347,
    height: 31.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.852,
    y: 390.395,
    style: {
      fill: "#FDE09C"
    },
    width: 31.347,
    height: 31.799
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.803,
    y: 337.032,
    style: {
      fill: "#FDE09C"
    },
    width: 31.347,
    height: 31.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.803,
    y: 283.679,
    style: {
      fill: "#FDE09C"
    },
    width: 31.347,
    height: 31.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.803,
    y: 390.395,
    style: {
      fill: "#FDE09C"
    },
    width: 31.347,
    height: 31.799
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#663300"
    },
    d: "M284.147,363.572c0-15.545-12.601-28.147-28.147-28.147l-20.898,74.897L256,478.24h28.147V363.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#983300"
    },
    d: "M227.853,363.572V478.24H256V335.425C240.455,335.425,227.853,348.027,227.853,363.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#663300"
    },
    d: "M364.695,363.572c0-15.545-12.601-28.147-28.147-28.147l-20.898,74.897l20.898,67.918h28.147V363.572 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#983300"
    },
    d: "M308.402,363.572V478.24h28.147V335.425C321.003,335.425,308.402,348.027,308.402,363.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#663300"
    },
    d: "M203.598,363.572c0-15.545-12.601-28.147-28.147-28.147l-20.898,74.897l20.898,67.918h28.147V363.572 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#983300"
    },
    d: "M147.304,363.572V478.24h28.147V335.425C159.906,335.425,147.304,348.027,147.304,363.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBA00"
    },
    d: "M256,209.872l-20.898,42.552L256,293.102c22.984,0,41.615-18.632,41.615-41.615 S278.984,209.872,256,209.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDE09C"
    },
    d: "M214.385,251.487c0,22.984,18.632,41.615,41.615,41.615v-83.23 C233.016,209.872,214.385,228.503,214.385,251.487z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversity);
export default __webpack_public_path__ + "static/media/University.a448f4597f9f57028333d5b119a76c15.svg";
export { ForwardRef as ReactComponent };